let nasal_spre_list= [
    {
        question: "SPECIFICATIONS FOR THE DRUG PRODUCT",
        answer:
            <ul>
                <li>Description</li>
                <li>Identification (primary and secondary).</li>
                <li>pH</li>
                <li>Osmolarity</li>
                <li>Valve Delivery (Shot Weight)</li>
                <li>Assay</li>
                <li>Unit Dose Content Uniformity</li>
                <li>Foreign particulate matter</li>
                <li>Concentration of tonicity agent (if any)</li>
                <li>Limit of chelating agent /Stabilizing agent (if any)</li>
                <li>Droplet size distribution</li>
                <li>Spray pattern and Plume geometry</li>
                <li>Related substances/ Degradation profile</li>
            </ul>
    },
    {
        question: "DRUG PRODUCT CHARACTERIZATION STUDIES FOR SUBMISSION",
        answer:
            <ul>
                <li>Determination of Appropriate Storage Conditions</li>
                <li>Stability of Primary (Unprotected) Package</li>
                <li>Temperature Cycling</li>
                <li>Effect of Storage</li>
                <li>Droplet size distribution</li>
                <li>Plume Geometry</li>
                <li>Photo stability</li>
                <li>Aerodynamic particle size distribution with suitable expansion chamber</li>
            </ul>       
    },
    {
        question:
            "IN-VITRO BIO- EQUIVALENCE WITH STATISTICAL ANALYSIS (FOR SUBMISSION)",
        answer:
            <ul>
                <li>Single actuation content (test and Reference) (SAC) with PBE
                </li>
                <li>Droplet size distribution
                </li>
                <li>Drug in small particle/ droplet
                </li>
                <li>Spray pattern
                </li>
                <li>Plume Geometry
                </li>
                <li>Priming and Re-priming
                </li>
                <li>Q1-Q2 comparison
                </li>
            </ul>
    },
    {
        question:
            "INNOVATIVE IN-VITRO TESTING",
        answer:
            <ul>
                <li>Particle size and shape of API in formulation
                </li>
            </ul>

    },
];
export default nasal_spre_list
;